import AOS from 'aos'; // ✅ Correct import
import 'aos/dist/aos.css'; // Import the AOS styles

export const initAOS = () => {
    setTimeout(() => {
        AOS.init({
            once: true,
        });
    }, 100);
};
